var exports = {
  "WB": "FavoritesWelcomeSection.module__welcomeSection___R3lJZl",
  "r2": "FavoritesWelcomeSection.module__iconSection___R3lJZl",
  "P0": "FavoritesWelcomeSection.module__iconWrapper___R3lJZl",
  "Kk": "FavoritesWelcomeSection.module__icon___R3lJZl",
  "Jo": "FavoritesWelcomeSection.module__contentSection___R3lJZl",
  "R_": "FavoritesWelcomeSection.module__heading___R3lJZl",
  "h_": "FavoritesWelcomeSection.module__description___R3lJZl",
  "uN": "FavoritesWelcomeSection.module__tip___R3lJZl",
  "A2": "FavoritesWelcomeSection.module__actionSection___R3lJZl",
};

module.exports = exports;
